import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-phone-number',
	templateUrl: './phone-number.component.html',
	styleUrls: ['./phone-number.component.css'],
})
export class PhoneNumberComponent {
	@Input() phone: string;
	@Output() valueChanged = new EventEmitter<string>();

	constructor() {}

	changed() {
		console.log(this.phone);
	}
}
